// src/utils/CivicAuthMount.jsx
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import {
  CivicAuthProvider,
  UserButton,
  useUser,
  useWallet,
} from "@civic/auth-web3/react";
import { setUserPublicKey } from "./walletState.js";


function AuthWrapper() {
  const { user } = useUser();
  const { wallet, address } = useWallet({ type: "solana" });

  useEffect(() => {
    // console.log("AuthWrapper loaded", user, wallet);
    setUserPublicKey(address);

    if (user?.user) {
      console.log("Civic user found:", user.user);

      window.userContext = {
        ...user,
        solana: wallet,
        createWallet: async () => {
          await wallet.createWallet();
          window.userContext.solana = wallet;
        },
      };

      window.dispatchEvent(new Event("civic-auth-complete"));
    }
  }, [user?.user, wallet]);
  // console.log("Rendering Civic UserButton", user, wallet);

  return (
    <div className="my-button-container">
      <UserButton
        className="login-button"
        dropdownButtonClassName="internal-button"
      />
    </div>
  );
}

export function mountCivicAuth(containerId = "flex-buttons", clientId) {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error(
      `[CivicAuth] Container #${containerId} not found. Skipping mount.`
    );
    return;
  }

  if (container.querySelector("#civic-user-button-container")) {
    console.log("[CivicAuth] Already mounted, skipping.");
    return;
  }

  const reactMount = document.createElement("div");
  reactMount.id = "civic-user-button-container";
  container.appendChild(reactMount);

  const root = ReactDOM.createRoot(reactMount);
  root.render(
    <CivicAuthProvider
      clientId={clientId}
    >
      <AuthWrapper />
    </CivicAuthProvider>
  );
}